import { useMemo } from 'react';
import useRetrieveAllUpstreamDataOutputs from '@/hooks/api/steps/useRetrieveAllUpstreamDataOutputs.ts';
import { makeDynamicOptionValue } from '@/pages/Editor/components/SharedFields/DataInputSelector/hooks/useDataInputOptions.ts';

type returnType = {
  outputs: { value: string; label: string }[];
  isPending: boolean;
};

const useRetrieveUpstreamDataOutputs = (
  stepId: string,
  scopeOverride?: 'root' | 'local_subflow',
): returnType => {
  const { data: allDataOutputs, isPending } = useRetrieveAllUpstreamDataOutputs(scopeOverride);

  const stepDataOutputs = useMemo(() => {
    return (
      Object.entries(allDataOutputs?.step_data_outputs || {}).find(
        (step) => step[0] === stepId,
      )?.[1] || []
    ).map((dataOutput) => ({
      value: makeDynamicOptionValue(dataOutput.step_id, dataOutput.output_id),
      label: dataOutput.output_name
        ? `${dataOutput.step_name} - ${dataOutput.output_name}${dataOutput.is_scope_promoted ? ' (promoted)' : ''}`
        : `${dataOutput.step_name}${dataOutput.is_scope_promoted ? ' (promoted)' : ''}`,
    }));
  }, [allDataOutputs?.step_data_outputs, stepId]);

  return { outputs: stepDataOutputs, isPending };
};

export default useRetrieveUpstreamDataOutputs;
